import React from 'react';
import { FileUploadDownload } from '../../../common/formElements/FileUploadDownload';

const EncryptFileTest = ({ projectId, version, envType }) => {
  return (
    <div className="w-100">
      <FileUploadDownload
        url={`${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/encrypt-file/`}
        projectId={projectId}
        maxFiles={1}
        maxSizeBytes="52428800"
        fileIcon="pages"
        envType={envType}
        isDecrypt={false}
      />
    </div>
  );
};

export default EncryptFileTest;
